import { Injectable, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, AbstractControl, Validators, FormControl, FormArray } from '@angular/forms';
import 'rxjs/Rx';
import { Observable } from 'rxjs'
import 'rxjs';
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
//import { ToastrService } from 'ngx-toastr';
import { environment } from '../../environments/environment';
import { mergeMap, map } from 'rxjs/operators';
import { Subject } from 'rxjs'
import { CookieService } from 'ngx-cookie-service';

import { DatePipe } from '@angular/common';
//import { CookieService } from 'ngx-cookie-service';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import * as jsPDF from 'jspdf';
import 'jspdf-autotable';
import { formatDate } from "@angular/common";
import { tick } from '@angular/core/testing';
import { isNullOrEmptyString } from '@progress/kendo-angular-grid/dist/es2015/utils';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import { ToastrService } from 'ngx-toastr';

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

@Injectable({
  providedIn: 'root'
})
export class CommonService {


  messageShowTimeOut = 1500;
  pageSize = 10;

  



  constructor(private router: Router, private datepipe: DatePipe, private http: HttpClient, private toastr: ToastrService, private _CookieService: CookieService ) {



  }
  dateFormat = this._CookieService.get("dateformat");

  getValidationMessage(formcontrol: AbstractControl, errorkey: string, lablename: string, key: string, skipKey: string): string {
    let errormessage;
    if (errorkey == 'required')
      errormessage = lablename + ' Required';
    if (errorkey == 'email' || errorkey == 'pattern')
      errormessage = 'Invalid ' + lablename;
    if (errorkey == 'minlength') {
      let length = formcontrol.errors[errorkey].requiredLength;
      // errormessage = lablename + ' Must Have ' + length + ' Letters';
      errormessage = 'Enter the data with minimum(' + length + ') fixed length'
    }
    if (errorkey == 'maxlength' && key != skipKey) {
      let length = formcontrol.errors[errorkey].requiredLength;
      // errormessage = lablename + ' Must Have ' + length + ' Letters';
      errormessage = 'Enter the data with maximum(' + length + ') fixed length'
    }
    if (errorkey == 'maxlength' && key == skipKey) {
      errormessage = 'Invalid ' + lablename;
    }
    return errormessage;
  }
  getAPI(apiPath, params, parameterStatus) {

    let urldata = environment.apiURL;
    // let httpHeaders = new HttpHeaders({
    //   'Content-Type': 'application/json',
    //   'Cache-Control': 'no-cache'
    // });
    // httpHeaders.append('Access-Control-Allow-Origin', '/*');

    // let options = {
    //   headers: httpHeaders
    // };
    if (parameterStatus.toUpperCase() == 'YES')

      return this.http.get(urldata).pipe(
        mergeMap(json => this.http.get(json[0]['ApiHostUrl'] + apiPath, { params }).map(this.extractData).catch(this.handleError)));
    else
      return this.http.get(urldata).pipe(
        mergeMap(json => this.http.get(json[0]['ApiHostUrl'] + apiPath).map(this.extractData).catch(this.handleError)));

  }
  postAPI(apiPath, data) {

    let urldata = environment.apiURL;
    let httpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache'
    });
    httpHeaders.append('Access-Control-Allow-Origin', '/*');

    let options = {
      headers: httpHeaders
    };
    return this.http.get(urldata).pipe(
      mergeMap(json => this.http.post(json[0]['ApiHostUrl'] + apiPath, data, options).map(this.extractData).catch(this.handleError)));

  }
  _getSubscriberchitdetails(Mobileno) {
    debugger
    const params = new HttpParams().set('Mobileno', Mobileno);
    return this.getAPI('/GetSubscriberChitDetails', params, 'YES')
}

getFormatDateGlobal(date: any): string | null {

  this.dateFormat = sessionStorage.getItem("dateformat");
  if (this.dateFormat == "MM DD YYYY") {
    return this.datepipe.transform(date, 'MM dd yyyy')
  }
  if (this.dateFormat == "DD MM YYYY") {
    return this.datepipe.transform(date, 'dd MM yyyy')
  }
  if (this.dateFormat == "YYYY MM DD") {
    return this.datepipe.transform(date, 'yyyy MM dd')
  }
  if (this.dateFormat == "DD/MM/YYYY") {
    return this.datepipe.transform(date, 'dd/MM/yyyy')
  }
  if (this.dateFormat == "MM/DD/YYYY") {
    return this.datepipe.transform(date, 'MM/dd/yyyy')
  }
  if (this.dateFormat == "YYYY/MM/DD") {
    return this.datepipe.transform(date, 'yyyy/MM/dd')
  }
  if (this.dateFormat == "DD-MM-YYYY") {
    return this.datepipe.transform(date, 'dd-MM-yyyy')
  }
  if (this.dateFormat == "MM-DD-YYYY") {
    return this.datepipe.transform(date, 'MM-dd-yyyy')
  }
  if (this.dateFormat == "YYYY-MM-DD") {
    return this.datepipe.transform(date, 'yyyy-MM-dd')
  }
  if (this.dateFormat == "DD-MMM-YYYY") {
    return this.datepipe.transform(date, 'dd-MMM-yyyy')
  }
  if (this.dateFormat == "MMM-DD-YYYY") {
    return this.datepipe.transform(date, 'MMM-dd-yyyy')
  }
  if (this.dateFormat == "YYYY-MMM-DD") {
    return this.datepipe.transform(date, 'yyyy-MMM-dd')
  }
}
public removeCommasInAmount(value) {
  if (this.isNullOrEmptyString(value))
    value = 0;
  return parseFloat(value.toString().replace(/,/g, ""))
  // let a = value.split(',')
  // let b = a.join('')
  // let c = b
  // return c;
}
isNullOrEmptyString(value): boolean {
  let isvalid = false;
  if (value == undefined || value == '' || value == null)
    isvalid = true;
  return isvalid;
}
// public getIPAddress()  
// {  
//   return this.http.get("http://api.ipify.org/?format=json");  
// } 
_getSubscriberchitinformationdetails(groupcodetickectno) {
  debugger
  const params = new HttpParams().set('groupcodetickectno', groupcodetickectno);
  return this.getAPI('/GetSubscriberChitDetailsbasedongroupcode', params, 'YES')
}

getIpAddress() {
  return this.http
        .get('http://freegeoip.net/json/?callback')
        .map(response => response || {})
        .catch(this.handleError);
}
  //Not used(Repeated)
  postAPIMultipleParameters(apiPath) {
    let urldata = environment.apiURL;
    let httpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache'
    });
    httpHeaders.append('Access-Control-Allow-Origin', '/*');

    let options = {
      headers: httpHeaders
    };

    
    return this.http.get(urldata).pipe(
      mergeMap(json => this.http.post(json[0]['ApiHostUrl'] + apiPath, options).map(this.extractData).catch(this.handleError)));

  }
  public extractData(res: Response) {

    let body = res;
    return body;
  }

  public handleError(error: Response | any) {
    debugger

    return Observable.throw(error.statusText);
  }
  showErrorMessage(errormsg: string) {
    debugger
    this.toastr.error(errormsg, "Error!", { timeOut: this.messageShowTimeOut });
  }
  showErrorMessageForLessTime(errormsg: string) {
    debugger
    this.toastr.error(errormsg, "Error!", { timeOut: this.messageShowTimeOut });
  }

  showInfoMessage(errormsg: string) {

    this.toastr.success(errormsg, "Success!", { timeOut: this.messageShowTimeOut });
  }

  showSuccessMessage() {
    this.toastr.success("Saved successfully", "Success", { timeOut: this.messageShowTimeOut });
  }
  showSuccessMsg(message) {
    this.toastr.success(message, "Success", { timeOut: this.messageShowTimeOut });
  }
  showWarningMessage(message) {
    this.toastr.warning(message, 'Warning!', { timeOut: 3000 });
  }
 }










